(function() {
  'use strict';
  
  const DISCOUNT_MULTIPLIER = 0.85;
  const PRICE_CONTAINER = '.price-add-to-cart';
  const MONEY_SPAN = '.money';
  
  let isUpdating = false;
  
  function updatePrice() {
    if (isUpdating) return;
    isUpdating = true;
    
    try {
      const container = document.querySelector(PRICE_CONTAINER);
      if (!container) {
        console.warn('Price container not found');
        return;
      }

      // Try to find .money span, if not found, use container directly
      const moneyEl = container.querySelector(MONEY_SPAN) || container;

      let basePrice = parseFloat(container.dataset.basePrice);
      
      if (isNaN(basePrice)) {
        console.warn('Invalid base price:', container.dataset.basePrice);
        return;
      }

      const sellingPlan = document.querySelector('input[name="selling_plan"]');
      const isSubscription = sellingPlan && sellingPlan.value && sellingPlan.value.trim() !== '';

      const newPrice = isSubscription ? (basePrice * DISCOUNT_MULTIPLIER) : basePrice;

      moneyEl.textContent = '$' + newPrice.toFixed(2);
      
      console.log('Price updated:', { isSubscription, basePrice, newPrice, sellingPlanValue: sellingPlan?.value });
      
    } catch (error) {
      console.error('Error updating price:', error);
    } finally {
      setTimeout(() => { isUpdating = false; }, 100);
    }
  }

  function init() {
    setTimeout(() => {
      updatePrice();
      
      const observer = new MutationObserver(() => {
        setTimeout(updatePrice, 50);
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value']
      });
      
      document.addEventListener('variant:changed', updatePrice);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();